export default __webpack_public_path__ + "78e1480c05e13ed844ef57fbce771623.png";